import type { Invitation } from "../../lib/types";

interface Props {
  invitation: Invitation;
  onEdit: () => void;
}

export function Confirmation({ invitation, onEdit }: Props) {
  const attendees = [
    ...invitation.memberNames
      .map((name, i) => ({ name, response: invitation.responses[i] }))
      .filter((entry) => entry.response.attending)
      .map((entry) => ({ name: entry.name, meal: entry.response.meal })),
    ...(invitation.plusOne?.attending
      ? [{ name: invitation.plusOne.name, meal: invitation.plusOne.meal }]
      : []),
  ];
  const anyoneAttending = attendees.length > 0;

  return (
    <div className="confirm">
      <div className="monogram confirm__monogram" role="img" aria-label="Aimee and Benjamin monogram" />
      <h3 className="h3">
        {anyoneAttending ? "Thank you — we have you down" : "We will miss you"}
      </h3>
      <p className="body confirm__body">
        {anyoneAttending
          ? "You are on the list for July 9 at Stone Tower Winery. We will send travel details and a final schedule in the spring."
          : "Thank you for letting us know. We will raise a glass to you from the lawn, and we hope to see you soon after."}
      </p>

      {anyoneAttending && (
        <ul className="confirm__summary">
          {attendees.map((guest) => (
            <li key={guest.name}>
              {guest.name} · {guest.meal}
            </li>
          ))}
        </ul>
      )}

      <p className="fine confirm__fine">
        A confirmation is on its way to your email. Need to change something? Reply to that note
        any time before June 15.
      </p>

      <button type="button" className="btn btn--outline" onClick={onEdit}>
        Edit our response
      </button>
    </div>
  );
}
